import script from "./growing-tiptap.vue?vue&type=script&setup=true&lang=js"
export * from "./growing-tiptap.vue?vue&type=script&setup=true&lang=js"

import "./growing-tiptap.vue?vue&type=style&index=0&id=05e50188&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05e50188"]])

export default __exports__